import { ClientOnly } from 'zudoku/components';
import * as schematicComponents from '@schematichq/schematic-components';

export default function Pricing() {
    return <ClientOnly>
        <schematicComponents.EmbedProvider
            apiKey={process.env.ZUDOKU_PUBLIC_SCHEMATIC_PUBLISHABLE_API_KEY}
            settings={{
                theme: {
                    numberOfColumns: 1,
                    sectionLayout: 'merged',
                    primary: '#ffffff',
                    secondary: '#f1f1f1',
                    card: {
                        background: '#0c0c0d',
                        borderRadius: 0,
                        padding: 24,
                    },
                    typography: {
                        heading1: {
                            fontFamily: 'Geist, sans-serif',
                            fontSize: 24,
                            color: '#ffffff',
                            fontWeight: 500,
                        },
                        heading2: {
                            fontFamily: 'Geist, sans-serif',
                            fontSize: 29,
                            color: '#ffffff',
                            fontWeight: 500,
                        },
                        heading3: {
                            fontFamily: 'Geist, sans-serif',
                            fontSize: 20,
                            color: '#ffffff',
                            fontWeight: 500,
                        },
                        heading4: {
                            fontFamily: 'Geist, sans-serif',
                            fontSize: 18,
                            color: '#ffffff',
                            fontWeight: 500,
                        },
                        heading5: {
                            fontFamily: 'Geist, sans-serif',
                            fontSize: 17,
                            color: '#ffffff',
                            fontWeight: 500,
                        },
                        heading6: {
                            fontFamily: 'Geist, sans-serif',
                            fontSize: 14,
                            color: '#ffffff',
                            fontWeight: 500,
                        },
                        text: {
                            fontFamily: 'Geist, sans-serif',
                            fontSize: 16,
                            color: '#ffffff',
                            fontWeight: 500,
                        },
                        link: {
                            fontFamily: 'Geist, sans-serif',
                            fontSize: 16,
                            color: '#ffffff',
                            fontWeight: 500,
                        },
                    },
                },
                badge: {
                    alignment: 'start',
                    visibility: 'visible'
                },
            }}
        >
            <schematicComponents.PricingTable
                callToActionUrl="https://sparkscan.io/dashboard/billing"
                showPeriodToggle={true}
                showDiscount={true}
                header={{
                    isVisible: false,
                }}
            />
        </schematicComponents.EmbedProvider>
    </ClientOnly>;
}